var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneWorkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "#007FA1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 4.5H14.375C14.1679 4.5 14 4.64924 14 4.83333V10.1667C14 10.3508 14.1679 10.5 14.375 10.5H22.625C22.8321 10.5 23 10.3508 23 10.1667V4.83333C23 4.64924 22.8321 4.5 22.625 4.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.546 3.95472V3.13654C20.546 2.91955 20.4598 2.71144 20.3063 2.558C20.1529 2.40456 19.9448 2.31836 19.7278 2.31836H17.2733C17.0563 2.31836 16.8482 2.40456 16.6947 2.558C16.5413 2.71144 16.4551 2.91955 16.4551 3.13654V3.95472",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.546 3.95472V3.13654C20.546 2.91955 20.4598 2.71144 20.3063 2.558C20.1529 2.40456 19.9448 2.31836 19.7278 2.31836H17.2733C17.0563 2.31836 16.8482 2.40456 16.6947 2.558C16.5413 2.71144 16.4551 2.91955 16.4551 3.13654V3.95472",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16965 11.7014C9.94762 13.2919 11.2369 14.5753 12.8309 15.346C12.9475 15.4013 13.0765 15.4252 13.2052 15.4155C13.3339 15.4058 13.4579 15.3627 13.5648 15.2905L15.9119 13.7254C16.0157 13.6562 16.1352 13.6139 16.2594 13.6025C16.3837 13.5911 16.5088 13.6109 16.6235 13.66L21.0144 15.5419C21.1636 15.6052 21.2881 15.7154 21.3693 15.8556C21.4504 15.9959 21.4838 16.1588 21.4643 16.3197C21.3255 17.4057 20.7956 18.4039 19.9739 19.1273C19.1521 19.8508 18.0948 20.2499 17 20.25C13.6185 20.25 10.3755 18.9067 7.98439 16.5156C5.5933 14.1245 4.25 10.8815 4.25 7.49997C4.25006 6.40513 4.64918 5.34786 5.37264 4.5261C6.0961 3.70435 7.09428 3.17448 8.18028 3.03569C8.34117 3.01622 8.50403 3.04956 8.64432 3.1307C8.78461 3.21183 8.89473 3.33636 8.9581 3.48552L10.8416 7.88032C10.8903 7.994 10.9101 8.11796 10.8994 8.24116C10.8886 8.36436 10.8475 8.48299 10.7798 8.58647L9.22011 10.9696C9.14912 11.0768 9.10716 11.2006 9.09831 11.3288C9.08947 11.4571 9.11405 11.5855 9.16965 11.7014V11.7014Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWorkIcon);
export default __webpack_public_path__ + "static/media/phone-work-icon.ee646f4c735a46b73bb3dd38163a7bce.svg";
export { ForwardRef as ReactComponent };